import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../api/axios'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tenants: [],
    categories: [],
    page: 1,
    keyword: '',
    categoryId: '',
    categorySlug: '',
    sort: false
  },
  mutations: {
    successFetchTenants (state, payload) {
      state.tenants = payload
    },
    successFetchCategories (state, payload) {
      state.categories = payload.categories
    },
    sortList (state, payload) {
      state.sort = payload
      state.page = 1
    },
    sortCategory (state, payload) {
      state.categoryId = payload.id
      state.page = payload.page
    },
    viewAll (state, payload) {
      state.categoryId = ''
      state.sort = false
      state.page = 1
    },
    loadMore (state, payload) {
      console.log(payload, 'loadmore')
      state.page = payload
    },
    appendTenants (state, payload) {
      const tenantsList = _.flattenDeep([...state.tenants.results.data, payload.results.data])
      state.tenants = payload
      state.tenants.results.data = tenantsList
    }
  },
  actions: {
    registerUser (context, payload) {
      const userData = { ...payload }
      if (userData.phone[0] === '8') {
        userData.phone = '0' + userData.phone
      } else if (userData.phone[0] === '6') {
        userData.phone = userData.phone.replace('62', '0')
      } else if (userData.phone[0] === '+') {
        userData.phone = userData.phone.replace('+62', '0')
      }
      axios({
        method: 'POST',
        url: '/user',
        data: {
          name: userData.name,
          email: userData.email,
          password: userData.password,
          phone: userData.phone,
          status: userData.status,
          bankCode: userData.status === 'Non Nasabah' ? userData.bankCode : null
        }
      }).then(({ data }) => {
        console.log(data)
      }).catch(err => console.log(err))
    },
    fetchTenants (context, payload) {
      // category id
      const categoryId = payload && payload.id ? payload.id : ''
      if (payload && Object.prototype.hasOwnProperty.call(payload, 'id') && payload.id) context.commit('sortCategory', payload)
      // keyword
      const keyword = payload && payload.keyword ? payload.keyword : ''
      // sort
      const sort = payload && payload.sort ? 'desc' : 'asc'
      if (payload && Object.prototype.hasOwnProperty.call(payload, 'sort')) context.commit('sortList', payload.sort)
      // page
      const page = payload && payload.page ? payload.page++ : 1
      if (payload && Object.prototype.hasOwnProperty.call(payload, 'page')) context.commit('loadMore', page)
      // url checking
      const url = categoryId || keyword || sort || page ? `/search-booth/page/${page}/sort/${sort}?keyword=${keyword}&category_id=${categoryId}` : '/search-booth/page/1/sort/asc?keyword=&category_id='
      // view all logic
      if (url === '/search-booth/page/1/sort/asc?keyword=&category_id=') context.commit('viewAll')
      axios.get(url, {}).then(({ data }) => {
        console.log(url, payload, categoryId, 'sort')
        console.log(data)
        page === 1 ? context.commit('successFetchTenants', data) : context.commit('appendTenants', data)
      }).catch((err) => console.log(err))
    },
    fetchCategories (context, payload) {
      axios.get('/get-categories', {}).then(({ data }) => {
        context.commit('successFetchCategories', data)
      }).catch((err) => console.log(err))
    }
  },
  modules: {
  }
})
